module.exports = __webpack_public_path__ + "static/img/oilApplicationBanner.65240c45.png";